<template>
  <div class="form-hyperlink-input form-item">
    <x-proxy-form-item
      :showRequired="showRequired"
      :label="widget.label"
      :processTitle="widget.processTitle"
      :validatorRules="validatorRules"
      :validateKey="validateKey"
      :validateInfo="validateInfo"
      @click.native="gotoUrlWhenRead"
      :disabled="widget.readOnly">
      <cube-input
        v-if="renderSence === 'edit' && !isUrl"
        v-model="formValue"
        :disabled="widget.readOnly"
        :placeholder="widget.readOnly ? '' : widget.placeholder"
        :maxlength="widget.lengthLimit"
        :tabindex="tabindex"
      ></cube-input>
      <cube-input
        v-if="renderSence === 'edit' && isUrl"
        v-model="formValue"
        :disabled="true"
        class="url"
        :placeholder="widget.readOnly ? '' : widget.placeholder"
        :maxlength="widget.lengthLimit"
        :tabindex="tabindex"
        @click.native="gotoUrl"
      ></cube-input>
      <input v-else-if="renderSence === 'read'" class="cube-input-field text-overflow" readonly :value="formValue || '-'" />
    </x-proxy-form-item>
    <div v-if="renderSence === 'edit' && !isUrl && !widget.readOnly" class="form-item-suffix" :class="{ 'full-height': (validateInfo.validate !== 'error') }">
      <x-svg-icon name="x-lib-ok" @click.native="change2Url"></x-svg-icon>
    </div>
    <div v-if="renderSence === 'edit' && isUrl && !widget.readOnly" class="form-item-suffix" :class="{ 'full-height': (validateInfo.validate !== 'error') }">
      <x-svg-icon name="edit-icon" @click.native="change2Url"></x-svg-icon>
    </div>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import WidgetEmailValidator from '../../../form-validator/widget-email-validator'

const hyperLinkValidator = function() {
  return (rule, hyperLink, callback) => {
    var re = new RegExp(/(http|https):\/\/([\w.]+\/?)\S*/)
    if (!hyperLink) {
      callback()
    } else {
      if (!re.test(hyperLink)) {
        callback(new Error('链接格式错误'))
      } else {
        callback()
      }
    }
  }
}

export default {
  name: 'FormHyperlinkInput',
  mixins: [FormWidgetConfigMixin],
  created() {
    this.widgetRules = [this._validate(hyperLinkValidator())]
  },
  data() {
    return {
      isUrl: false
    }
  },
  methods: {
    change2Url() {
      if (this.validateInfo.validate === 'error' && !this.isUrl) {
        return
      }
      if (this.formValue) {
        this.isUrl = !this.isUrl
      }
    },
    gotoUrl() {
      if (this.widget.readOnly) {
        if (this.formValue) {
          window.open(this.formValue, '_blank')
        }
      } else {
        if (this.isUrl) {
          window.open(this.formValue, '_blank')
        }
      }
    },
    gotoUrlWhenRead() {
      if (this.renderSence === 'edit' && this.widget.readOnly) {
        window.open(this.formValue, '_blank')
      }
    }
  }
}
</script>

<style lang="scss">
.form-hyperlink-input {
  position: relative;
  .url {
    text-decoration: underline;
    .cube-input-field {
      color: #0000EE;
    }
  }
  .disabled {
    .cube-input-field {
      color: #0000EE !important;
      text-decoration: underline !important;
    }
  }
  .form-item-suffix {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 3.43rem;
    width: 3.43rem;
    height: calc(100% - 1.71rem);
    font-size: 0;
    &.full-height {
      height: 100%;
    }
    .x-svg-icon {
      color: #B2B2B2;
    }
  }
}
</style>